import React, { Component } from "react";
import moment from "moment";
import FormatoDireccion from "./sub_components/formatoDireccion";
import ModalDireccion from "../common/scripts/modalDirecciones";

export default class Viajes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDireccion: false,
      visibleSelectorDocumento: false,
      visibleSelectorCiudades: false,
    };
    this.handleGenericHtml = this.handleGenericHtml.bind(this);
  }

  handleGenericHtml(data) {
    return { __html: data };
  }

  handleDireccionSubmit(direccion, observaciones) {
    this.props.handleDireccion(direccion, observaciones);
    this.setState({ showDireccion: false });
  }

  render() {
    let props = this.props;
    let nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      idList,
      direccion,
      ciudad,
      ciudadDestino,
      fecha,
      aceptaTC,
      ciudadesList;
    [
      nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      idList,
      direccion,
      ciudad,
      ciudadDestino,
      fecha,
      aceptaTC,
      ciudadesList,
    ] = [
      props.nombre,
      props.documentSelected.CSDocumentoIdentidadText,
      props.numeroDocumento,
      props.email,
      props.emailIsValid,
      props.celular,
      props.documentos,
      props.direccion,
      props.ciudad,
      props.ciudadDestino,
      props.fecha,
      props.aceptaTerminosCondiciones,
      props.ciudadesList,
    ];
    return (
      <section
        className="tab-pane fade form-container formularioSolicitud mainContent"
        id="nav-viajes"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <div>
          <ModalDireccion
            msg={
              <FormatoDireccion
                direccion={this.handleDireccionSubmit.bind(this)}
              />
            }
            showModal={this.state.showDireccion}
          />

          <h3>{i18next.t("forms.formViajetitulo")}</h3>
          <br></br>
          <div
            dangerouslySetInnerHTML={this.props.handleGenericHtml(
              i18next.t("forms.formViajeSubtitulo")
            )}
          />
          {/* <h4>{i18next.t("forms.formViajeSubtitulo")}</h4> */}
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.nombre")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={
                    nombre == "" || nombre == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={nombre}
                  onChange={() => props.handleInput(event)}
                  onFocus={() => props.handleInput(event)}
                  name="Nombre"
                />
                {nombre == "" || nombre == " " || nombre == null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.nombreError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-sm-4">
                <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                  Documento de identidad*
                </p>
                <p className="formularioSolicitud--text-aligned">
                  {i18next.t("forms.cedulaIndicacion")}
                </p>
              </div>
              <div className="col-sm-3">
                <button
                  disabled={false}
                  style={{ cursor: "pointer" }}
                  className="dropdown-toggle formularioSolicitud--dropDown"
                  // type="button"
                  id="dropdownCedula"
                  // data-toggle="dropdown"
                  // aria-haspopup="true"
                  // aria-expanded="true"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      visibleSelectorDocumento:
                        !this.state.visibleSelectorDocumento,
                    });
                  }}
                >
                  <div>
                    <p className="text-left">{id}</p>
                  </div>
                  <span className="caret"></span>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownCedula"
                    style={{
                      cursor: "pointer",
                      display: `${
                        this.state.visibleSelectorDocumento ? "block " : "none"
                      }`,
                    }}
                  >
                    {idList.map((item, index) => {
                      return (
                        <li
                          key={index}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              visibleSelectorDocumento: false,
                            });
                            props.updateocumentSelected(item);
                          }}
                        >
                          <p>{item.CSDocumentoIdentidadText}</p>
                        </li>
                      );
                    })}
                  </ul>
                </button>
              </div>
              <div className="col-sm-5">
                <input
                  style={{ cursor: "pointer" }}
                  disabled={false}
                  type="text"
                  className={
                    idNum == "" || idNum == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={idNum}
                  onChange={() => props.handleInput(event)}
                  name="NumeroDocumento"
                  maxLength={33}
                />
                {idNum == "" || idNum == " " || idNum == null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.cedulaError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.telefono")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={
                    celular == "" || celular == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={celular}
                  onChange={() => props.handleInput(event)}
                  name="Celular"
                  maxLength={13}
                />
                {celular == "" || celular == " " || celular == null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.telefonoError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.email")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={
                    email == "" || email == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={email}
                  onChange={() => props.handleInput(event)}
                  onFocus={() => props.handleInput(event)}
                  name="Email"
                />
                {email == "" ||
                email == " " ||
                email == null ||
                emailIsValid == false ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.emailError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.direccion")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={
                    direccion == "" || direccion == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={direccion}
                  onChange={() => props.handleInput(event)}
                  onFocus={() => props.handleInput(event)}
                  name="Direccion"
                />
                {direccion == "" || direccion == " " || direccion == null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.direccionError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.ciudadOrigen")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="text"
                  className={
                    ciudad == "" || ciudad == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  value={ciudad}
                  onChange={() => props.handleInput(event)}
                  onFocus={() => props.handleInput(event)}
                  name="Ciudad"
                />
                {ciudad == "" || ciudad == " " || ciudad == null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.ciudadError")}
                  </p>
                ) : null}
              </div>
            </div>

            {/* <div className="form-group row">
                            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">{i18next.t("forms.ciudadDestino")}</label>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    className={ciudadDestino == "" || ciudadDestino == " " || ciudadDestino === null ? "form-control formularioSolicitud--input formularioSolicitud--input-error " : "form-control formularioSolicitud--input"}
                                    value={ciudadDestino}
                                    onChange={() => props.handleInput(event)}
                                    onFocus={() => props.handleInput(event)}
                                    name="CiudadDestino" />
                                {ciudadDestino == "" || ciudadDestino == " " || ciudadDestino == null ? <p className="formularioSolicitud--input-errorLabel">{i18next.t("forms.ciudadDestinoError")}</p> : null}
                            </div>
                        </div> */}

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.ciudadDestino")}
              </label>
              <div className="col-sm-8" style={{ position: "relative" }}>
                <button
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      visibleSelectorCiudades:
                        !this.state.visibleSelectorCiudades,
                    });
                  }}
                  className="btn dropdown-toggle formularioSolicitud--dropDown formularioSolicitud--dropDown-none"
                  // type="button"
                  id="dropdowTipoHistoria"
                  // data-toggle="dropdown"
                  // aria-haspopup="true"
                  // aria-expanded="false"
                >
                  <div>
                    <p className="text-left">{ciudadDestino}</p>
                  </div>
                  <span className="caret"></span>
                  <ul
                    className="dropdown-menu dropdown-menu--margin"
                    aria-label="Seleccione Si o No segun su condiciòn si fue expedido o no "
                    style={{
                      cursor: "pointer",
                      display: `${
                        this.state.visibleSelectorCiudades ? "block " : "none"
                      }`,
                    }}
                  >
                    {ciudadesList.map((item, index) => {
                      return (
                        <li
                          key={index}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              visibleSelectorCiudades: false,
                            });
                            props.handleCiudadDestino(item);
                          }}
                        >
                          <p>{item}</p>
                        </li>
                      );
                    })}
                  </ul>
                </button>
                {ciudadDestino == "" ||
                ciudadDestino == " " ||
                ciudadDestino == null ||
                ciudadDestino == "Seleccione una opción" ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.ciudadDestinoError")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.fechaViaje")}
              </label>
              <div className="col-sm-8">
                <input
                  style={{ cursor: "pointer" }}
                  type="date"
                  min={moment().format("YYYY-MM-DD")}
                  name="FechaViaje"
                  value={fecha}
                  className={
                    fecha == "" || fecha == null
                      ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                      : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                  }
                  onChange={() => props.handleInput(event)}
                  onFocus={() => props.handleInput(event)}
                />
                {fecha === "" || fecha === null ? (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.errorFechaViaje")}
                  </p>
                ) : null}
              </div>
            </div>

            <div className="form-group row">
              <div
                dangerouslySetInnerHTML={props.handleGenericHtml(
                  i18next.t("forms.formViajeSubtitulo2")
                )}
              />
            </div>

            {/* <div className="form-group row">
                            <div className="center-block" style={{ width: "240px" }}>
                                <label className="checkbox-inline center-block"><input type="checkbox" checked={aceptaTC} /><a onChange={() => props.handleTerminosCondiciones()}>Acepto términos y condiciones</a></label>
                            </div>
                        </div> */}

            <div className="form-group row">
              <div className="center-block" style={{ width: "400px" }}>
                <div className="checkbox-inline center-block">
                  <div className="cotizar-form-controls btn-terminosCondiciones">
                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        this.props.handleTerminosCondiciones(true);
                      }}
                      className={`cotizar-form-controls-action ${
                        aceptaTC ? "active" : null
                      }`}
                    >
                      Si
                    </button>
                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        this.props.handleTerminosCondiciones(false);
                      }}
                      className={`cotizar-form-controls-action ${
                        !aceptaTC ? "active" : null
                      }`}
                    >
                      No
                    </button>
                  </div>
                  <label style={{ width: "200px" }}>
                    Autorización del tratamiento de los datos personales
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="center-block" style={{ width: "400px" }}>
                <div className="checkbox-inline center-block">
                  <div className="cotizar-form-controls  btn-terminosCondiciones">
                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        this.props.handleAceptaRecibirInformacion(true);
                      }}
                      className={`cotizar-form-controls-action ${
                        props.aceptaRecibirInformacion ? "active" : null
                      }`}
                    >
                      Si
                    </button>
                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        this.props.handleAceptaRecibirInformacion(false);
                      }}
                      className={`cotizar-form-controls-action ${
                        !props.aceptaRecibirInformacion ? "active" : null
                      }`}
                    >
                      No
                    </button>
                  </div>
                  <label style={{ width: "200px" }}>
                    Acepto recibir informacion de Compensar en mi correo
                    electronico, sms, whatsapp y comunicaciones fisicas
                  </label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 text-center">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => props.handlePlan("TemasCovid-Viajes")}
                  disabled={
                    nombre == null ||
                    nombre == "" ||
                    id == null ||
                    id == "elija un documento" ||
                    idNum == null ||
                    idNum == "" ||
                    email == null ||
                    emailIsValid == null ||
                    emailIsValid == false ||
                    celular == null ||
                    celular == "" ||
                    direccion == null ||
                    direccion == "" ||
                    ciudad == null ||
                    ciudad == "" ||
                    ciudadDestino == null ||
                    ciudadDestino == "" ||
                    aceptaTC == false ||
                    fecha == null ||
                    fecha == null
                      ? true
                      : false
                  }
                >
                  {i18next.t("forms.buttonSubmit")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    );
  }
}
